const product = {
  getlist: 'product/getlist-by-admin',
  add: 'product/add',
  update: 'product/update',
  remove: 'product/remove',
  get: 'product/get-by-admin',
  getall: 'product/getall',
  clearcache: 'product/clear-cache',
  bulkupdate: 'product/bulk-update',
  bulkupdatediscount: 'product/bulk-update-discount',
  importexcel: 'product/import-excel',
  duplicate: 'product/duplicate',
}
export default product
